export const colorCheckBoxBorder = "#757575";
export const TabSmall2Width = 40;
export const TabSmallWidth = 50;
export const TabDefaultWidth = 100;
export const TabContentWidth = 200;
export const mobileWidth = "620px";
export const mobileWidthNumber = 620;
export const FontFamily =
    '"Nunito Sans", "Helvetica Neue", Helvetica, Arial, sans-serif';
